import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from "recharts";
import { CHIP_COLORS } from "../utils/colors";

const data = [
  { hour: "00", demand: 2200 },
  { hour: "02", demand: 1800 },
  { hour: "04", demand: 1500 },
  { hour: "06", demand: 3200 },
  { hour: "08", demand: 6800 },
  { hour: "10", demand: 7500 },
  { hour: "12", demand: 8200 },
  { hour: "14", demand: 7800 },
  { hour: "16", demand: 6500 },
  { hour: "18", demand: 9200 },
  { hour: "20", demand: 8800 },
  { hour: "22", demand: 4500 },
];

const PeakDemandChart = () => {
  const maxDemand = Math.max(...data.map((d) => d.demand));

  return (
    <div className="bg-card rounded-xl border border-border p-5">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="font-heading font-semibold text-foreground">
            Peak Demand Hours
          </h3>
          <p className="text-sm text-muted-foreground mt-0.5">
            Hourly load distribution (kW)
          </p>
        </div>
        <div className="flex items-center gap-4 text-xs">
          <div className="flex items-center gap-1.5">
            <div
              className="w-3 h-3 rounded-sm"
              style={{ backgroundColor: CHIP_COLORS.info }}
            />
            <span className="text-muted-foreground">Normal</span>
          </div>
          <div className="flex items-center gap-1.5">
            <div
              className="w-3 h-3 rounded-sm"
              style={{ backgroundColor: CHIP_COLORS.warning }}
            />
            <span className="text-muted-foreground">Peak</span>
          </div>
        </div>
      </div>

      <div className="h-[180px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            margin={{ top: 5, right: 5, left: -20, bottom: 0 }}
          >
            <CartesianGrid
              strokeDasharray="3 3"
              stroke="hsl(var(--border))"
              vertical={false}
            />
            <XAxis
              dataKey="hour"
              axisLine={false}
              tickLine={false}
              tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 11 }}
              tickFormatter={(value) => `${value}:00`}
            />
            <YAxis
              axisLine={false}
              tickLine={false}
              tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 11 }}
              tickFormatter={(value) => `${(value / 1000).toFixed(0)}k`}
            />
            <Tooltip
              contentStyle={{
                backgroundColor: "hsl(var(--card))",
                border: "1px solid hsl(var(--border))",
                borderRadius: "8px",
              }}
              formatter={(value: number) => [
                `${value.toLocaleString()} kW`,
                "Demand",
              ]}
              labelFormatter={(label) => `${label}:00`}
            />
            <Bar dataKey="demand" radius={[4, 4, 0, 0]} maxBarSize={30}>
              {data.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={
                    entry.demand >= maxDemand * 0.85
                      ? CHIP_COLORS.warning
                      : CHIP_COLORS.info
                  }
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default PeakDemandChart;
